import { createContext } from "react";
import { FriendRequest } from '@/models/friend-request.ts';

export type FriendData = {
  id: string;
  name?: string;
  nickname?: string;
  image?: string;
}

type FriendsContextType = {
  friends: FriendData[];
  setFriends: (friends: FriendData[]) => void;
  toggleFriend: (id: string) => Promise<void>;
  isFriend: (id: string) => boolean;
  pendingRequests: FriendRequest[];
};

export const FriendsContext = createContext<FriendsContextType | null>(null);
